/* Brand chat button for Zendesk messaging: loads the widget on demand. */
(() => {
  const button = document.querySelector('[data-support-chat]');
  if (!button) return;
  const badge = button.querySelector('[data-support-chat-badge]');
  let loading = null;
  let isOpen = false;

  // While the chat is open the button turns into its close button (Zendesk has none on desktop).
  const setOpen = (open) => {
    isOpen = open;
    document.documentElement.classList.toggle('support-chat-open', open);
    button.setAttribute('aria-expanded', open);
    button.setAttribute('aria-label', open ? button.dataset.labelClose : button.dataset.labelOpen);
  };

  const load = () => {
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = `https://static.zdassets.com/ekr/snippet.js?key=${encodeURIComponent(button.dataset.supportChat)}`;
      script.async = true;
      script.onload = () => {
        const ready = () => {
          if (typeof window.zE !== 'function') return setTimeout(ready, 50);
          window.zE('messenger:on', 'open', () => setOpen(true));
          window.zE('messenger:on', 'close', () => setOpen(false));
          window.zE('messenger:on', 'unreadMessages', (count) => {
            badge.hidden = !count;
            badge.textContent = count > 9 ? '9+' : count || '';
          });
          resolve();
        };
        ready();
      };
      script.onerror = () => { loading = null; reject(); };
      document.head.appendChild(script);
    });
    return loading;
  };

  button.addEventListener('click', async () => {
    if (isOpen) return window.zE('messenger', 'close');
    button.classList.add('is-loading');
    try {
      await load();
      window.zE('messenger', 'open');
    } catch (e) {
      /* keep the button usable for another try */
    }
    button.classList.remove('is-loading');
  });

  // Visitors with an ongoing conversation get the widget early, so replies show as a badge.
  try {
    const hasConversation = Object.keys(localStorage).some((key) => key.startsWith('ZD-'));
    if (hasConversation) {
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 2000));
      idle(() => load().catch(() => {}));
    }
  } catch (e) { /* no storage */ }
})();
